// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1hOMb","additionalInfo":"AgreementModal_additionalInfo__esKw2"};